const toPrecision = (value: number, scale: number = 0): number => {
  if (value % 1 === 0 || scale < 0) {
    return value;
  }
  return Number(value.toFixed(scale));
};

export default toPrecision;
